import React from "react";
import { Link } from "react-router-dom";
import { useSidebar } from "@/contexts/SidebarContext";
import { MenuIcon } from "@/components/Icons/MenuIcon";
import { TenantHeaderTabs } from "./TenantHeaderTabs";
import { useNavbarNavigation } from "./hooks/useNavbarNavigation";
import { NotificationsTrigger } from "./NotificationsTrigger";
import { NAVBAR_CONFIG } from "./constants";
import { TenantHeaderPopover } from "./TenantHeaderPopover";
import { LanguageSelector } from "./LanguageSelector";
import LogoMark from "@/assets/images/logos/LogoMark.svg";
import DSInsightLogo from "@/assets/images/logos/DS-Insight™.svg";
import DSXRLogo from "@/assets/images/logos/DS_XR.svg";

/** Logo section component for tenant header - Desktop only */
const LogoSection: React.FC = () => (
  <div className="hidden lg:flex items-center gap-3">
    <img src={LogoMark} alt="LogoMark" className="h-5" />
    <img src={DSInsightLogo} alt="DS-Insight™" className="h-5" />
    <img src={DSXRLogo} alt="DS_XR" className="h-5" />
  </div>
);

/** Mobile logo - Simple logo mark */
const MobileLogo: React.FC = () => (
  <div className="flex lg:hidden items-center">
    <img src={LogoMark} alt="LogoMark" className="h-6" />
  </div>
);

export const TenantHeader: React.FC = () => {
  const { activeTab, setActiveTab } = useNavbarNavigation();
  const { toggleMobileSidebar } = useSidebar();

  const handleTabClick = (tabName: string) => {
    setActiveTab(tabName);
  };

  return (
    <nav
      className="w-full fixed top-0 left-0 right-0 z-50 border-b border-white/10"
      style={{ backgroundColor: NAVBAR_CONFIG.backgroundColor }}
    >
      <div
        className="mx-auto flex justify-between items-center px-4 lg:px-6"
        style={{ height: `${NAVBAR_CONFIG.height}px` }}
      >
        {/* Left Section - Mobile Menu + Logo + Navigation */}
        <div className="flex items-center gap-3">
          {/* Mobile Menu Button */}
          <button
            onClick={toggleMobileSidebar}
            className="lg:hidden p-2 text-white hover:bg-white/10 rounded-lg transition-colors"
            aria-label="Toggle menu"
          >
            <MenuIcon />
          </button>

          {/* Logo Section */}
          <Link to="/dashboard" className="flex items-center">
            <LogoSection />
            <MobileLogo />
          </Link>

          {/* Desktop Navigation Tabs */}
          <div className="hidden lg:block">
            <TenantHeaderTabs
              activeTab={activeTab}
              onTabClick={handleTabClick}
            />
          </div>
        </div>

        {/* Right Section - Language Selector, Notifications and User Menu */}
        <div className="flex items-center gap-2 lg:gap-4">
          {/* Language Selector - Visible on all screen sizes */}
          {/* <LanguageSelector /> */}

          <div className="h-[30px] w-px bg-white/20" />

          <div className="hidden sm:block">
            <NotificationsTrigger />
          </div>

          <div className="hidden sm:block h-[30px] w-px bg-white/20" />

          <TenantHeaderPopover />
        </div>
      </div>
    </nav>
  );
};
